import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { FuseSharedModule } from "@fuse/shared.module";

import { MatSidenavModule } from "@angular/material/sidenav";
import { DialogBoxDebidaDiligenciaComponent } from "./dialog/dialog-box-debida-diligencia.component";

import { DebidaDiligenciaComponent } from "./debidas-diligencias.component";
import { MisDebidaDiligenciaComponent } from "./mis-debida-diligencias.component";
import { DebidaDiligenciaViewComponent } from "./debida-diligencia-view.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatSelectModule } from "@angular/material/select";
import { IniciarDebidaDiligenciaComponent } from "./iniciar-debida-diligencia.component";
import { DialogBoxPrintComponentDebidaDiligencia } from "./dialog/dialog-print-box.component";
import { SentenciaTableComponent } from "./component/sentencia-table.component";
import { SentenciaTreeComponent } from "./component/sentencia-tree.component";
import { SentenciaResultadoTableComponent } from "./component/sentencia-resultado-table.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { TranslateModule } from "@ngx-translate/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTabsModule } from "@angular/material/tabs";
import { MatStepperModule } from "@angular/material/stepper";
import { DialogBoxCambioEstadoComponent } from "./dialog/dialog-box-cambio-estado.component";
import { DialogBoxCopiarComponent } from "./dialog/dialog-box-copiar.component";
import { DialogAnalisisBoxAnalyticsComponentDebidaDiligencia } from "./dialog/dialog-analisis-analytics-box.component";
import { DialogAnalisisComparatorBoxAnalyticsComponentDebidaDiligencia } from "./dialog/dialog-analisis-analytics-comparator-box.component";
import { DialogAnalisisBoxPrintComponentDebidaDiligencia } from "./dialog/dialog-analisis-print-box.component";
import { EvaluacionModule } from "../evaluacion/evaluacion.module";
import { MatTreeModule } from "@angular/material/tree";
import { KeysPipe } from "./dialog/json-keys.pipe";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { MatPaginatorModule } from "@angular/material/paginator";
import { SujetoObligadoComponent } from "./sujeto-obligado/sujetos-obligados.component";
import { SujetoObligadoDialogBoxComponent } from "./sujeto-obligado/dialog/sujeto-obligado-dialog-box.component";
import { SelectClientesSujetoObligadoComponent } from "./sujeto-obligado/dialog/dialog-box-clientes.component";
import { DialogBoxSetPasswordComponent } from "./sujeto-obligado/dialog/dialog-box-set-password.component";
import { TipoSujetoObligadoComponent } from "./tipo-sujeto-obligado/tipo-sujeto-obligado.component";
import { TipoSujetoObligadoDialogBoxComponent } from "./tipo-sujeto-obligado/dialog/dialog-box.component";
import { TipoOperacionComponent } from "./tipo-operacion/tipo-operacion.component";
import { TipoOperacionDialogBoxComponent } from "./tipo-operacion/dialog/dialog-box.component";
import { OrigenDeFondosDialogBoxComponent } from "./origen-de-fondos/dialog/dialog-box.component";

import { TipoDocumentoComponent } from "./tipo-documento/tipo-documento.component";
import { TipoDocumentoDialogBoxComponent } from "./tipo-documento/dialog/dialog-box.component";

import { ProfesionComponent } from "./profesion/profesion.component";
import { ProfesionDialogBoxComponent } from "./profesion/dialog/dialog-box.component";
import { SectorActividadComponent } from "./actividad-sector/actividad-sector.component";
import { SectorActividadDialogBoxComponent } from "./actividad-sector/dialog/dialog-box.component";
import { SujetoObligadoViewComponent } from "./sujeto-obligado/sujeto-obligado-view.component";
import { MonedaComponent } from "./moneda/moneda.component";
import { MonedaDialogBoxComponent } from "./moneda/dialog/dialog-box.component";
import { PaisComponent } from "./pais/pais.component";
import { PaisDialogBoxComponent } from "./pais/dialog/dialog-box.component";
import { ClientesSujetoObligadoComponent } from "./sujeto-obligado/cliente/clientes-sujetos-obligados.component";
import { ClienteDialogBoxComponent } from "./sujeto-obligado/cliente/dialog/dialog-box.component";
import { LinkRelacionadoDialogBoxComponent } from "./sujeto-obligado/cliente/dialog/link-relacionado-dialog-box.component";
import { ClienteDialogBoxAntecedentesComponent } from "./sujeto-obligado/cliente/dialog/dialog-box-antecedentes.component";
import { ClienteSujetoObligadoViewComponent } from "./sujeto-obligado/cliente/cliente-sujeto-obligado-view.component";
import { DebidaDiligenciaViewExternalComponent } from "./debida-diligencia-external-view.component";
import { DebidaDiligenciaFormViewComponent } from "./debida-diligencia-form-view.component";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { RepresentanteDialogBoxComponent } from "./sujeto-obligado/dialog/dialog-representante-box.component";
import { ClienteSujetoObligadoExternalViewComponent } from "./sujeto-obligado/cliente/cliente-sujeto-obligado-external-view.component";
import { AccionistaDialogBoxComponent } from "./sujeto-obligado/cliente/dialog/dialog-accionista-box.component";
import { ClienteComponent } from "./sujeto-obligado/cliente/forms/cliente.component";
import { FormularioDialogBoxComponent } from "./sujeto-obligado/dialog/dialog-formulario-box.component";
import { OrigenDeFondosComponent } from './origen-de-fondos/origen-de-fondos.component';
import { PonderacionDeRiesgosComponent } from './ponderacion-de-riesgos/ponderacion-de-riesgos.component';
import { PonderacionDeRiesgosDialogBoxComponent} from './ponderacion-de-riesgos/dialog/dialog-box.component';
import { PonderacionDeRiesgosResultsTableComponent } from './ponderacion-de-riesgos/component/results-table.component';
import {FiltrosDebidaDiligenciaComponent} from './sujeto-obligado/filtros.component';

@NgModule({
    declarations: [
        DebidaDiligenciaComponent,
        MisDebidaDiligenciaComponent,
        IniciarDebidaDiligenciaComponent,
        DialogBoxPrintComponentDebidaDiligencia,
        SujetoObligadoDialogBoxComponent,
        DebidaDiligenciaViewComponent,
        DialogBoxCambioEstadoComponent,
        DialogBoxCopiarComponent,
        DialogAnalisisBoxPrintComponentDebidaDiligencia,
        DialogBoxDebidaDiligenciaComponent,
        SentenciaTableComponent,
        SentenciaTreeComponent,
        SujetoObligadoComponent,
        SentenciaResultadoTableComponent,
        DialogAnalisisBoxAnalyticsComponentDebidaDiligencia,
        DialogAnalisisComparatorBoxAnalyticsComponentDebidaDiligencia,
        SelectClientesSujetoObligadoComponent,
        DialogBoxSetPasswordComponent,
        TipoSujetoObligadoComponent,
        TipoSujetoObligadoDialogBoxComponent,
        TipoOperacionComponent,
        TipoOperacionDialogBoxComponent,
        TipoDocumentoComponent,
        TipoDocumentoDialogBoxComponent,
        SujetoObligadoViewComponent,
        MonedaComponent,
        MonedaDialogBoxComponent,
        PaisComponent,
        PaisDialogBoxComponent,
        ProfesionComponent,
        ProfesionDialogBoxComponent,
        SectorActividadComponent,
        SectorActividadDialogBoxComponent,
        KeysPipe,
        ClientesSujetoObligadoComponent,
        ClienteDialogBoxComponent,
        ClienteDialogBoxAntecedentesComponent,
        ClienteSujetoObligadoViewComponent,
        DebidaDiligenciaViewExternalComponent,
        DebidaDiligenciaFormViewComponent,
        RepresentanteDialogBoxComponent,
        AccionistaDialogBoxComponent,
        ClienteSujetoObligadoExternalViewComponent,
        FormularioDialogBoxComponent,
        ClienteComponent,
        OrigenDeFondosComponent,
        OrigenDeFondosDialogBoxComponent,
        PonderacionDeRiesgosComponent,
        PonderacionDeRiesgosDialogBoxComponent,
        PonderacionDeRiesgosResultsTableComponent,
        LinkRelacionadoDialogBoxComponent,
        FiltrosDebidaDiligenciaComponent
    ],
    imports: [
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatAutocompleteModule,
        TranslateModule,
        MatSnackBarModule,
        FuseSharedModule,
        MatIconModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatTabsModule,
        MatStepperModule,
        EvaluacionModule,
        MatSidenavModule,
        MatTreeModule,
        NgxChartsModule,
        MatPaginatorModule,
        ClipboardModule,
    ],
    entryComponents: [
        OrigenDeFondosDialogBoxComponent,
        DialogBoxPrintComponentDebidaDiligencia,
        SujetoObligadoDialogBoxComponent,
        IniciarDebidaDiligenciaComponent,
        DebidaDiligenciaViewComponent,
        DialogBoxCambioEstadoComponent,
        DialogBoxCopiarComponent,
        DialogAnalisisBoxPrintComponentDebidaDiligencia,
        DialogBoxDebidaDiligenciaComponent,
        SentenciaTableComponent,
        SentenciaTreeComponent,
        SentenciaResultadoTableComponent,
        DialogAnalisisBoxAnalyticsComponentDebidaDiligencia,
        DialogAnalisisComparatorBoxAnalyticsComponentDebidaDiligencia,
        SelectClientesSujetoObligadoComponent,
        DialogBoxSetPasswordComponent,
        TipoSujetoObligadoComponent,
        TipoSujetoObligadoDialogBoxComponent,
        TipoOperacionComponent,
        TipoOperacionDialogBoxComponent,
        TipoDocumentoComponent,
        TipoDocumentoDialogBoxComponent,
        SujetoObligadoViewComponent,
        ProfesionDialogBoxComponent,
        MonedaComponent,
        PaisComponent,
        PaisDialogBoxComponent,
        MonedaDialogBoxComponent,
        SectorActividadComponent,
        SectorActividadDialogBoxComponent,
        ProfesionComponent,
        ClientesSujetoObligadoComponent,
        ClienteDialogBoxComponent,
        ClienteDialogBoxAntecedentesComponent,
        FormularioDialogBoxComponent,
        ClienteSujetoObligadoViewComponent,
        DebidaDiligenciaViewExternalComponent,
        DebidaDiligenciaFormViewComponent,
        RepresentanteDialogBoxComponent,
        ClienteSujetoObligadoExternalViewComponent,
        ClienteComponent,
        OrigenDeFondosComponent,
        PonderacionDeRiesgosComponent,
        PonderacionDeRiesgosDialogBoxComponent,
        PonderacionDeRiesgosResultsTableComponent,
        LinkRelacionadoDialogBoxComponent,
        FiltrosDebidaDiligenciaComponent
    ],
    exports: [
        ClienteComponent,
        SentenciaTableComponent,
        SentenciaTreeComponent,
        SentenciaResultadoTableComponent,
        PonderacionDeRiesgosResultsTableComponent,
        FiltrosDebidaDiligenciaComponent
    ],
})
export class DebidaDiligenciaModule {}
